const gallery = document.querySelector('media-gallery');
const productPath = window.location.pathname.replace(/\/$/, '');

if (gallery && productPath.includes('/products/')) {
  fetch(`${productPath}.js`, {
    headers: { Accept: 'application/json' },
  })
    .then((response) => (response.ok ? response.json() : null))
    .then((product) => {
      if (!product?.media?.length) return;

      const videos = product.media.filter((media) => media.media_type === 'video');
      if (!videos.length) return;

      const missingVideos = videos.filter((video) => !document.querySelector(`[data-media-id="${video.id}"]`));
      if (!missingVideos.length) return;

      const rail = document.createElement('div');
      rail.className = 'hd-product-video-fallback';

      missingVideos.forEach((video) => {
        const source = video.sources?.find((item) => item.format === 'mp4') || video.sources?.[0];
        if (!source?.url) return;

        const card = document.createElement('article');
        card.className = 'hd-product-video-fallback__card product-media-container product-media-container--video';
        card.dataset.mediaId = String(video.id);

        const media = document.createElement('video');
        media.className = 'hd-product-video-fallback__video';
        media.controls = true;
        media.playsInline = true;
        media.preload = 'metadata';
        media.poster = video.preview_image?.src || '';
        media.setAttribute('aria-label', video.alt || `${product.title} video`);

        const sourceElement = document.createElement('source');
        sourceElement.src = source.url;
        sourceElement.type = source.mime_type || source.mimeType || 'video/mp4';
        media.append(sourceElement);

        card.append(media);
        rail.append(card);
      });

      if (rail.children.length) {
        gallery.insertAdjacentElement('afterend', rail);
      }
    })
    .catch(() => {});
}
